// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginTokenForm_form__2Qkrs","error-label":"LoginTokenForm_error-label__12hxm","buttons":"LoginTokenForm_buttons__21WAs"};